import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'SERVICE_PRODUCTS';

export default createListReducer(TEMPLATE_NAME);
